import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { authUtils } from '../utils/auth';
import { api } from '../services/api';

const ProtectedRoute = ({ children }) => {
  const [isValidating, setIsValidating] = useState(true);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    const validateToken = async () => {
      const token = authUtils.getToken();

      if (!token) {
        setIsValidating(false);
        setIsValid(false);
        return;
      }

      try {
        // Try to validate with backend
        await api.validateToken(token);
        setIsValid(true);
      } catch (error) {
        console.error('Token validation failed:', error);
        // If backend validation fails but token exists, allow access anyway
        // This handles cases where the backend /validate/token endpoint has issues
        if (token) {
          console.log('Backend validation failed, but token exists - allowing access');
          setIsValid(true);
        } else {
          authUtils.removeToken();
          setIsValid(false);
        }
      } finally {
        setIsValidating(false);
      }
    };

    validateToken();
  }, []);

  if (isValidating) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-gray-600">Validating access...</p>
        </div>
      </div>
    );
  }

  return isValid ? children : <Navigate to="/admin/login" replace />;
};

export default ProtectedRoute;
